
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Receipt from '../components/Receipt'
import {
  fetchBillingChargeByWorkspaceSlugAndChargeId,
  fetchBillingByWorkspaceSlugIfNeeded,
  receiptPageLoad
} from 'actions'
import {
  getChargeById,
  isRequestingChargeById,
  getBilling
} from 'selectors'

class ReceiptApp extends Component {
  render () {
    return React.createElement(Receipt, this.props)
  }

  componentDidMount () {
    const { workspaceSlug, chargeId } = this.props.params
    this.props.onMount(workspaceSlug, chargeId)
  }
}

function mapStateToProps (state, ownProps) {
  const { workspaceSlug, chargeId } = ownProps.params
  return {
    payment: getChargeById(state, chargeId),
    billing: getBilling(state, workspaceSlug),
    isRequesting: isRequestingChargeById(state, chargeId)
  }
}

function mapDispatchToProps (dispatch) {
  return {
    onMount (workspaceSlug, chargeId) {
      dispatch(receiptPageLoad())
      dispatch(fetchBillingByWorkspaceSlugIfNeeded(workspaceSlug))
      dispatch(fetchBillingChargeByWorkspaceSlugAndChargeId(workspaceSlug, chargeId))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReceiptApp)



// WEBPACK FOOTER //
// ./containers/ReceiptApp.js